import { ClientUserListResponseItem } from '~bank-client-users/types'

export interface ClientUsersTableProps {
  setEditClientUser: (item: ClientUserListResponseItem) => void
  setRemovingClientUser: (item: ClientUserListResponseItem) => void
  sendInviteLink: ({ id }: { id: string }) => void
}
